import React, { useState } from 'react';
import View from 'src/components/view';
import styles from 'src/components/css/loja_online.module.css';
import utils from 'src/components/utils';
import Element from 'src/components/element';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import MK from 'src/components/MK';
import { useEffect } from 'react';
import { useCallback } from 'react';

const paisMapping = {
  MEX: 'mx',
  ECU: 'ec',
};

const LojaOnline = function () {
  const user = utils.getUser();
  const cm = user?.cliente?.pessoa?.codigo;
  const [openDialog, setOpenDialog] = useState(false);

  // Dados da tela
  let [link, setLink] = useState();
  const [consultor, setConsultor] = useState();
  const [sizeInput, setSizeInput] = useState(11);

  // Dados da tabela
  const [index, setIndex] = useState(0);
  let [crudPedido, setCrudPedido] = useState({ data: {}, changed: {}, tabSel: 'PEDIDOS' });
  let [element, setElement] = useState({});
  let [ready, setReady] = useState(false);

  // Fechar Dialog
  const handleCloseDialog = function () {
    setLink();
    setConsultor();
    window.location.reload();
  };

  const handleResize = useCallback(() => {
    if (!!window) {
      const widthScreen = window.innerWidth;

      if (widthScreen < 1841) {
        setSizeInput(10);
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  // WARN: Essa função só funciona em localhost ou HTTPS
  const copiar = (elementId) => {
    var copyText = document.getElementById(elementId);

    copyText.select();
    copyText.setSelectionRange(0, 99999);

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(copyText.value).catch((err) => {
        console.error('Erro ao copiar texto:', err);
      });
    } else {
      console.error('API Clipboard não disponível ou em contexto inseguro.');
    }
  };

  const pais = paisMapping[user?.cliente?.pais?.codigo] || 'ec';

  // Link da loja virtual
  const gerarLoja = () => {
    link = `https://${pais}.nipponflex.com/${cm}&${consultor.codigo}`;
    setLink(link);
    setOpenDialog(true);
  };

  const createElement = function () {
    return {
      elements: {
        pedidos: {
          name: 'itens',
          type: 'list',
          layout: 'table',
          rows: 10,
          add: false,
          showLabel: true,
          empty: 'Sin solicitudes',
          rowStyleClass: "${'ui-row-' + @this.constante_status}",
          list: {
            url: 'listarMeusPedidosShopify?orcamento=false&id_cliente=' + user?.cliente?.id,
          },
          columns: {
            abrir_pedido: {
              type: 'button',
              columnStyle: { width: 70 },
              icon: 'fa fa-plus',
              click: {
                action: 'open',
                url: '/carrinho/pedido/{id_pedido}',
              },
            },
            numero_pedido: {
              type: 'span',
              value: "${'Pedido ' + @this.numero_pedido}",
            },
            dh_registro: { label: 'Data do pedido', type: 'span', bold: true },
            valor_total: { label: 'Valor total', type: 'span', format: 'money', bold: true },
            quantidade: { label: 'Itens no pedido', type: 'span', bold: true },
            descricao_status: { label: 'Status do pedido', type: 'span', bold: true },
          },
        },
      },
    };
  };

  if (!ready) {
    element = createElement();
    setElement(element);
    ready = true;
    setReady(true);
  }

  crudPedido.open = function (value, args) {
    const click = value.click;

    if (!click) {
      return;
    }
    const data = args.data;
    let d = {};
    let url = click.url;

    for (const i in data) {
      const v = data[i];
      const b = '{' + i + '}';
      const c = v + '';

      url = url.replace(b, c);
    }
    d.path = url;
    d.label = click.label;

    window.location.href = url;
  };

  crudPedido.setarTab = function (_el, args) {
    crudPedido.tabSel = args.data.key;

    element = createElement();
    setElement(element);

    index = index + 1;
    setIndex(index + 1);
    setCrudPedido(crudPedido);
    setElement(element);
  };

  return (
    <View styleClass="ui-full-page" className={styles.content} name="loja-online">
      <h1 className={styles.title}>{utils.lng('store', 'TIENDA').toUpperCase()} ONLINE</h1>
      <div className={styles.containerMain}>
        <h2 className={styles.text}>
          {utils.lng(
            'loja_online_textMain',
            'A continuación se muestra la dirección de su tienda en línea para compras con descuentos de di o ventas al consumidor final',
          )}
        </h2>

        <div className={styles.containerLink}>
          <div className={styles.fieldLink}>
            <input id="link" value={`https://${pais}.nipponflex.com/${cm}`} />
          </div>
          <a id="copy_link" className={`ui-button-link ${styles.btnExpandMobile}`} onClick={() => copiar('link')}>
            {utils.lng('copy', 'Copiar')}
          </a>
        </div>

        <p className={styles.text}>
          {utils.lng('loja_online_textConsultor', 'También puede generar tiendas virtuales para sus consultores.')}
        </p>

        <div>
          <MK.Entity
            field="consultor"
            label="Consultor"
            entity="Cliente"
            space={sizeInput}
            change={(args) => {
              setConsultor(args?.crud?.data.consultor);
            }}
          ></MK.Entity>

          {consultor && (
            <button className={`ui-button-link ${styles.btnExpandMobile}`} onClick={gerarLoja}>
              Generar Tienda
            </button>
          )}

          {/* Dialog de 'Gerar Loja' */}
          <Dialog maxWidth="lg" onClose={handleCloseDialog} aria-labelledby="customized-dialog-title" open={openDialog}>
            <DialogTitle>
              <span className={styles.messageDialog}>
                {utils.lng(
                  'loja_online_textDialog',
                  '¡Listo! La tienda virtual de su consultor ya está activa; comparta el enlace y comience a vender.',
                )}
              </span>
            </DialogTitle>
            <DialogContent className={styles.contentDialog}>
              <div className={styles.containerLink}>
                <div className={styles.fieldLink}>
                  <input id="link-consultor" value={link} />
                </div>
                <a
                  id="copy_link"
                  className={`ui-button-link ${styles.btnExpandMobile}`}
                  onClick={() => {
                    copiar('link-consultor');
                  }}
                >
                  {utils.lng('copy', 'Copiar')}
                </a>
              </div>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleCloseDialog} color="primary">
                {utils.lng('close', 'Cerrar').toUpperCase()}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>

      {/*
      <div className="ui-meus-pedidos">
        <MK.Grid field="pedidos" list={{ url: 'listarMeusPedidos?orcamento=false' }}>
          <MK.Column field="numero_pedido" label="Número" />
          <MK.Column field="dh_registro" label="Data de registro" />
          <MK.Column field="valor_total" label="Valor Total" format="money" />
          <MK.Column field="quantidade" label="Quantidade" format="integer" default={0} />
          <MK.Column field="descricao_status" label="Status" format="status" trueLabel="Pagamento Aprovado" />
          <MK.Column icon="fa fa-edit" field="icon">
            <Button>Ver Detalhes</Button>
          </MK.Column>
        </MK.Grid>
      </div>
        */}

      <h2 className={styles.titleList}>{`${utils.lng('my', 'Mis')} ${utils.lng('orders', 'Pedidos')}`} </h2>

      <Element index={index} value={element} crud={crudPedido} data={crudPedido.data} />
    </View>
  );
};

export default LojaOnline;
